import TaskDetails from 'components/hyperdrive/Tasks/TaskDetails'
import React from 'react'

export default function TaskDrawer({ closeModal }) {
    return (
        <TaskDetails closeModal={closeModal} />
    )
}
